// utils/roomUtils.js

// Filters a comma/arrow-separated "next rooms" string down to rooms staff
// still need to act on. Rooms 7001 (Completed) and 10001 are excluded since
// staff already know about those and don't need them called out. Shared by
// DateRangeReport.jsx (the Production Report) and the Lookout List so both
// present the same "still pending" room list for an order.
export const filterNextRooms = (nextRoomsStr) => {
  if (!nextRoomsStr) return '';
  const rooms = nextRoomsStr.split(/[,→>-]+/).map(r => r.trim());
  const filtered = rooms.filter(r => r && r !== '7001' && r !== '10001');
  return filtered.join(' , ');
};
